import React, { useState } from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "./components/Login";
import OffboardingForm from "./components/OffboardingForm";
import Confirmation from "./components/Confirmation";
import HistoryView from "./components/HistoryView";
import OnboardingForm from "./components/OnboardingForm";
import OnboardingConfirmation from "./components/OnboardingConfirmation";
import OnboardingHistoryView from "./components/OnboardingHistoryView";
import MovementForm from "./components/MovementForm";
import MovementConfirmation from "./components/MovementConfirmation";
import MovementHistoryView from "./components/MovementHistoryView";
import "./App.css";

// ── Offboarding section ──────────────────────────────────────────────────────
function OffboardingSection() {
  const [view, setView] = useState("form"); // "form" | "confirmation" | "history"
  const [submittedData, setSubmittedData] = useState(null);

  const handleSubmitted = (data) => {
    setSubmittedData(data);
    setView("confirmation");
  };

  const goToForm = () => {
    setSubmittedData(null);
    setView("form");
  };

  const goToHistory = () => setView("history");

  if (view === "confirmation") {
    return (
      <Confirmation
        submittedData={submittedData}
        onNewRequest={goToForm}
        onViewHistory={goToHistory}
      />
    );
  }

  if (view === "history") {
    return <HistoryView onNewRequest={goToForm} />;
  }

  return <OffboardingForm onSubmitted={handleSubmitted} onViewHistory={goToHistory} />;
}

// ── Onboarding section ───────────────────────────────────────────────────────
function OnboardingSection() {
  const [view, setView] = useState("form"); // "form" | "confirmation" | "history"
  const [submittedData, setSubmittedData] = useState(null);

  const handleSubmitted = (data) => {
    setSubmittedData(data);
    setView("confirmation");
  };

  const goToForm = () => {
    setSubmittedData(null);
    setView("form");
  };

  const goToHistory = () => setView("history");

  if (view === "confirmation") {
    return (
      <OnboardingConfirmation
        submittedData={submittedData}
        onNewRequest={goToForm}
        onViewHistory={goToHistory}
      />
    );
  }

  if (view === "history") {
    return <OnboardingHistoryView onNewRequest={goToForm} />;
  }

  return <OnboardingForm onSubmitted={handleSubmitted} onViewHistory={goToHistory} />;
}

// ── Movement section ─────────────────────────────────────────────────────────
function MovementSection() {
  const [view, setView] = useState("form"); // "form" | "confirmation" | "history"
  const [submittedData, setSubmittedData] = useState(null);

  const handleSubmitted = (data) => { setSubmittedData(data); setView("confirmation"); };
  const goToForm    = () => { setSubmittedData(null); setView("form"); };
  const goToHistory = () => setView("history");

  if (view === "confirmation") {
    return <MovementConfirmation submittedData={submittedData} onNewRequest={goToForm} onViewHistory={goToHistory} />;
  }
  if (view === "history") {
    return <MovementHistoryView onNewRequest={goToForm} />;
  }
  return <MovementForm onSubmitted={handleSubmitted} onViewHistory={goToHistory} />;
}

// ── App shell with module toggle ─────────────────────────────────────────────
function AppContent() {
  const [module, setModule] = useState("onboarding"); // "onboarding" | "offboarding" | "movement"

  return (
    <div>
      <nav className="module-nav">
        <div className="module-nav-inner">
          <button
            className={`module-tab${module === "onboarding" ? " module-tab-active" : ""}`}
            onClick={() => setModule("onboarding")}
          >
            Onboarding
          </button>
          <button
            className={`module-tab${module === "offboarding" ? " module-tab-active" : ""}`}
            onClick={() => setModule("offboarding")}
          >
            Offboarding
          </button>
          <button
            className={`module-tab${module === "movement" ? " module-tab-active" : ""}`}
            onClick={() => setModule("movement")}
          >
            Movement
          </button>
        </div>
      </nav>
      {module === "offboarding" ? <OffboardingSection /> :
       module === "movement"    ? <MovementSection />    :
       <OnboardingSection />}
    </div>
  );
}

export default function App() {
  return (
    <>
      <AuthenticatedTemplate>
        <AppContent />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
}
